import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { OverquotaViewerModalProps } from './OverquotaViewerModal';

export const renderOverquotaViewerModal = (data: OverquotaViewerModalProps = {}) =>
    openPopupHelper({ popupName: popupNames.OVERQUOTA_VIEWER_MODAL, data });
